module.exports = __webpack_public_path__ + "images/category_lp/home_appliance/store_images/1_bfd7033c7a3122ea0f5b33ead5ee7ba6.png";